import gql from 'graphql-tag'

import { FamilyFieldsFragment, IFamily } from '../family'

export interface IUserWithFamily {
  family: IFamily
}

export const UserWithFamilyFieldsFragment = gql`
  fragment UserWithFamilyFields on User {
    family {
      ...FamilyFields
    }
  }

  ${FamilyFieldsFragment}
`
